var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 96,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.234 39.817l-5.956 5.617-5.53-11.3 2.856-6.497c.722-1.296 1.903-1.313 2.624 0l6.005 12.18z",
    fill: "#ffa000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f57f17",
    d: "M84.28 45.43L62 66.418l16.75-32.284z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.765 31.227c1.067-1.03 2.166-.682 2.443.78L105 66.135l-19.21 11.68c-.674.38-2.46.53-2.46.53s-1.625-.2-2.248-.548L62 66.418l34.765-35.192z",
    fill: "#ffca28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.75 34.133L62 66.417l7.465-47.188c.28-1.462 1.1-1.61 1.837-.315l7.448 15.22z",
    fill: "#ffa000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/Firebase.958f967145c869f1aecff0a1c12cdb8b.svg";
export { ForwardRef as ReactComponent };